import './FooterContact.scss'

import React, {Fragment} from 'react'
import {Link} from '../../../util/link'
import {style} from '../../../util/style'
import {Icon} from '../../ui/Icon'

const styles = style('footercontact', ['item'])

export type FooterContactType = {
	address?: string
	phone?: string
	email?: string
	iban?: string
}

export const FooterContact: React.FC<FooterContactType> = ({
	address,
	phone,
	email,
	iban
}) => {
	if (!address && !phone && !email) return null
	const trimmedPhone = phone.replace(/[^\d]/g, '')

	return (
		<div className={styles()}>
			<FooterContactItem type="address" data={address} icon="pin" />
			<FooterContactItem
				type="phone"
				data={phone}
				icon="phone"
				to={`tel:${trimmedPhone}`}
			/>
			<FooterContactItem
				type="email"
				data={email}
				icon="mail"
				to={`mailto:${email}`}
			/>
			<FooterContactItem type="creditcard" data={iban} icon="creditcard" />
		</div>
	)
}

const FooterContactItem: React.FC<{
	type: string
	data: string
	icon: 'creditcard' | 'mail' | 'phone' | 'pin'
	to?: string
}> = ({type, data, icon, to}) => {
	if (!data) return null
	const LinkTag = to ? Link : Fragment
	const linkProps = to ? {to} : {}

	return (
		<div className={styles.item().mod(type)}>
			<LinkTag {...linkProps} className={styles.item('link')}>
				<span className={styles.item('icon')}>
					<Icon icon={icon} />
				</span>
				<p className={styles.item('text')}>{data}</p>
			</LinkTag>
		</div>
	)
}
